module.exports = __webpack_public_path__ + "static/media/type.d2ab117f.svg";